enum GeneralStatus {
    Pending		= 10,
	ActiveOrApproved	= 90,
	Inactive	    = 91,
	Archived = 99,
	Deleted = 100
}

export default GeneralStatus;
